module.exports = __webpack_public_path__ + "static/img/qryunwei.4371195.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/qryunwei.jpg
// module id = qS6e
// module chunks = 1